/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type ConsultationFrequency from "parog-web/models/consultation/consultation-frequency";
import type Patient from "parog-web/models/patient";
import type ConfigurationService from "parog-web/services/configuration";
import { Configuration } from "parog-web/services/configuration";

interface ConsultationFrequencyPhysicalEditionFormArgs {
  patient: Patient;
}

export default class ConsultationFrequencyPhysicalEditionForm extends Component<ConsultationFrequencyPhysicalEditionFormArgs> {
  @service declare configuration: ConfigurationService;

  static forcDisplayName = "Santé physique > Consultations";

  get consultationFrequencies(): Array<ConsultationFrequency> {
    return this.configuration
      .configurationForPatient(Configuration.Consultation, this.args.patient)
      .consultationFrequencies.filter(
        consultation => consultation.type == "physical"
      );
  }
}
